import MainNavbar from "../../molecules/mainNavbar/MainNavbar";
import ContactContainer from "./ContactContainer";
import Footer from "./../../molecules/footer/Footer";

const Contact = () => {
  return (
    <>
      <MainNavbar />
      <ContactContainer />
      <Footer />
    </>
  );
};

export default Contact;
